import { Spinner } from '@nike/eds'
import React from 'react'

interface LoadingOverlayProps {
  visible: boolean
}

export const LoadingOverlay = ({ visible }: LoadingOverlayProps) => {
  if (!visible) return null

  return (
    <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-70 z-10">
      <Spinner size="large" />
    </div>
  )
}
